import { ClientCategory } from "@/api/types/categories";
import { useNavigate } from "@/utils/navigate-to-products";
import { Dropdown, Button } from "antd";
import { FC } from "react";
import { DownOutlined } from "@ant-design/icons";

import styles from "./categories.module.css";

type CategoryProps = {
  category: ClientCategory;
};

export const Category: FC<CategoryProps> = ({ category }) => {
  const { categoryName, subcategories } = category;
  const { navigateToCategory } = useNavigate();

  return (
    <Dropdown
      menu={{
        items: subcategories?.map((subcategory) => ({
          key: subcategory.id,
          label: (
            <div
              className={styles.subcategory}
              onClick={() =>
                navigateToCategory(subcategory.id, subcategory.categoryName)
              }
            >
              {subcategory.categoryName}
            </div>
          ),
        })),
      }}
      disabled={!subcategories}
    >
      <div>
        <Button
          onClick={() => navigateToCategory(category.id, category.categoryName)}
          type="text"
          className={styles.category}
        >
          {categoryName}
          {subcategories && <DownOutlined className={styles.shevron} />}
        </Button>
      </div>
    </Dropdown>
  );
};
